import { render, staticRenderFns } from "./DiscoveryCoursesDefault.vue?vue&type=template&id=3dba3504&"
import script from "./DiscoveryCoursesDefault.vue?vue&type=script&lang=js&"
export * from "./DiscoveryCoursesDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports